import React from 'react';

import {
  DashboardContentLayout,
  RoutedTabs,
  RoutedTabsProps,
} from '@portals/framework';

import { AllStoreListingsTable } from './store-listing-table/AllStoreListingsTable';
import { ArchivedStoreListingsTable } from './store-listing-table/ArchivedStoreListingsTable';
import { DraftStoreListingsTable } from './store-listing-table/DraftStoreListingsTable';
import { PublishedStoreListingsTable } from './store-listing-table/PublishedStoreListingsTable';
import { StoreListingsTableContextProvider } from './store-listing-table/StoreListingTableContextProvider';

const ROUTES: RoutedTabsProps['routes'] = [
  {
    path: 'all',
    tabLabel: 'All Products',
    element: <AllStoreListingsTable />,
  },
  {
    path: 'published',
    tabLabel: 'Published',
    element: <PublishedStoreListingsTable />,
  },
  {
    path: 'draft',
    tabLabel: 'Draft',
    element: <DraftStoreListingsTable />,
  },
  {
    path: 'archived',
    tabLabel: 'Archived',
    element: <ArchivedStoreListingsTable />,
  },
];

export function StoreListingsPage() {
  return (
    <DashboardContentLayout pageTitle="Product Listings">
      <StoreListingsTableContextProvider>
        <RoutedTabs routes={ROUTES} basePath="/products" />
      </StoreListingsTableContextProvider>
    </DashboardContentLayout>
  );
}
